<!--
 * @Author: fanyang 1050549505@qq.com
 * @Date: 2022-04-29 10:44:55
 * @LastEditors: fanyang 1050549505@qq.com
 * @LastEditTime: 2022-08-30 09:52:24
 * @FilePath: /dhgx-supervise/src/views/login/login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<style lang="less"></style>

<template>
  <div class="sso"></div>
</template>
<script>
import config from "@/config";
import { datasApi } from "@/api/dataApi";
export default {
  name: "sso",
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  filters: {},
  created() {},
  mounted() {
    this.sso();
  },
  methods: {
    async sso() {
      const ssoUrl = config.ssoUrl;
      datasApi
        .sso()
        .then(res => {
          if (res.code == 1) {
            sessionStorage.setItem("isLogin", 1);
            sessionStorage.setItem("userInfo", JSON.stringify(res.data));
            this.$router.push({ path: "/dashboard" });
          } else {
            location.href = ssoUrl;
          }
        })
        .catch(err => {
          this.$message.error("系统异常");
        });
    }
  }
};
</script>
